import { FilterOptions } from "./types/filterOptions";
import { FilterTag } from "./types/filterTag";

class FilterTagsAndOptionsService {
  createFilterTags(appliedFilterOptions: FilterOptions): FilterTag[] {
    let tags: FilterTag[] = [];
    const assessmentsAvailableTags = this.createAssessmentAvailableTags(appliedFilterOptions);
    const videoStatusTags = this.createVideoStatusTags(appliedFilterOptions);
    const rebaScoreTags = this.createRebaScoreTags(appliedFilterOptions);
    
    tags = tags
      .concat(assessmentsAvailableTags)
      .concat(videoStatusTags)
      .concat(rebaScoreTags);
      
    return tags;
  }

  removeFilterTag(filterTags: FilterTag[], filterTagToRemove: FilterTag): FilterTag[] {
    return filterTags.filter((filterTag) => filterTag.value !== filterTagToRemove.value || filterTag.optionName !== filterTagToRemove.optionName);
  }

  getUpdatedAppliedFilterOptionsOnTagRemoval(
    appliedFilterOptions: FilterOptions,
    optionName: keyof FilterOptions,
    valueToBeRemoved: string
  ): FilterOptions {
    let updatedFilterOptions = { ...appliedFilterOptions };
    updatedFilterOptions = this.getUpdatedFilterOptionsWhenToBeClearedIsTypeArray(
      updatedFilterOptions,
      optionName,
      valueToBeRemoved
    );
    return updatedFilterOptions;
  }

  private getUpdatedFilterOptionsWhenToBeClearedIsTypeArray(
    filterOptions: FilterOptions,
    optionName: keyof FilterOptions,
    valueToBeRemoved: string|number
  ) {
    if (Array.isArray(filterOptions[optionName])) {
      const filteredArray = (filterOptions[optionName] as (string)[]).filter(
        (tagValue: string) => tagValue !== valueToBeRemoved
      );
      return {
        ...filterOptions,
        [optionName]: filteredArray
      };
    }
    return filterOptions;
  }

  private createRebaScoreTags(appliedFilterOptions: FilterOptions): FilterTag[] {
    return appliedFilterOptions.rebaScoreRanges.map((rebaScore: string) => {
      return {
        prefix: "Reba score: ",
        value: rebaScore,
        optionName: "rebaScoreRanges"
      };
    });
  }

  private createVideoStatusTags(appliedFilterOptions: FilterOptions): FilterTag[] {
    return appliedFilterOptions.videoStatuses.map((videoStatus: string) => {
      return {
        prefix: "Video status: ",
        value: videoStatus,
        optionName: "videoStatuses"
      };
    });
  }

  private createAssessmentAvailableTags(appliedFilterOptions: FilterOptions): FilterTag[] {
    return appliedFilterOptions.assessmentsAvailable.map((assessmentAvailableType: string) => {
      return {
        prefix: "Assessments available: ",
        value: assessmentAvailableType,
        optionName: "assessmentsAvailable"
      };
    });
  }
}

export default new FilterTagsAndOptionsService();
